import React from "react";
import TimeAgo from "react-timeago";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Typography,
  List,
} from "@material-ui/core";

import {
  Card,
  Spacing,
} from "~/src/components/global";

import { JobListItem } from "~/src/components/jobs";

const useStyles = makeStyles((theme) => ({
  message: {
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.border.base}`,
  },
  other: {
    alignSelf: "flex-start",
    background: theme.palette.background.paper,
  },
  self: {
    alignSelf: "flex-end",
    background: theme.palette.background.dark,
  },
  timestamp: {
    marginTop: theme.spacing(0.25),
  },
}));

export default function Header(props) {
  const {
    data, otherName, self,
  } = props;
  const classes = useStyles();
  const {
    author, timestamp, text, job, type,
  } = data;

  const selfWroteMessage = author === self.id;

  const timestampFormatter = (value, unit, suffix) => {
    if (value === 0) return null;

    let _unit = unit;
    if (value !== 1) _unit += "s";

    return `${value} ${_unit} ${suffix}`;
  };

  const renderTextMessage = () => {
    const messageClasses = classNames(
      classes.message,
      selfWroteMessage ? classes.self : classes.other,
    );

    return (
      <Box className={messageClasses} p={2}>
        <Typography>{text}</Typography>

        <Typography variant="caption" color="textSecondary" className={classes.timestamp}>
          <TimeAgo date={timestamp && timestamp.seconds && new Date(timestamp.seconds * 1000)} minPeriod={60} formatter={timestampFormatter} />
        </Typography>
      </Box>
    );
  };

  const renderJobMessage = () => {
    const selfOwnsJob = (job.studio && job.studio.id === self.id) || job.authID === self.id;

    let text = "";
    if (selfWroteMessage) {
      if (selfOwnsJob) {
        text = `You requested ${otherName} for this job`;
      } else {
        text = "You applied for this job";
      }
    } else if (selfOwnsJob) {
      text = `${otherName} applied for this job`;
    } else {
      text = `${otherName} requested you for this job`;
    }

    return (
      <Card>
        <List>
          <JobListItem job={job} />
        </List>

        <Spacing extraTight />
        <Typography color="textSecondary">{text}</Typography>
        <Typography variant="caption" color="textSecondary" className={classes.timestamp}>
          <TimeAgo date={timestamp && timestamp.seconds && new Date(timestamp.seconds * 1000)} />
        </Typography>
      </Card>
    );
  };

  return type === "job" ? renderJobMessage() : renderTextMessage();
}
